import { MapfreCardComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { DocumentsDataService } from "./../../../../../_services/data-services/documents-data.service";
import { StorageServiceObservablesService } from "@services/storage-service-observables/storage-service-observables.service";
import { Component, OnInit, OnDestroy, HostListener, ElementRef } from "@angular/core";
import { ActivatedRoute, Params, Router , RouterModule } from '@angular/router';
import { PolicyDataService } from "./../../../../../_services/data-services/policy-data.service";
import { PolicyDetailsService } from "./../../../../../_services/my-insurance/policy-details.service";
import { UserService } from "../../../../../_services/user.service";
import { WalletCardService } from "../../../../../_services/_iam/wallet-card.service";
import { PaperlessService } from "../../../../../_services/_iam/paperless.service";
import { AlertService, AcmicService } from "@mapfre-design-library/src/public_api";
import { FlagDataService } from "../../../../../_services/data-services/flag-data.service";
import { FlagResponse } from "../../../../../_models/flag-response";
import { Capacitor } from "@capacitor/core";
import { ErrorRedirectionService } from "../../../../../_services/error-service/error-redirection.service";
import { IdCardService } from "@services/id-card.service";
import { CompanyTypeService } from "../../../../../_services/_iam/company-type.service";
import { SortByDatePipe } from "@helpers/_pipes/sort-by-date.pipe";
import { SortPipe } from "@helpers/_pipes/sort.pipe";
import { PolicyBillingUploadService } from "@services/policy-billing-upload.service";
import { SearchPipe } from "@helpers/_pipes/search-pipe.pipe";
import { EventService } from "@services/event-service.service";
import { UrlValidationService } from "@services/document/url-validation.service";

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, MapfreCardComponent],
  selector: "app-bn-document-details",
  templateUrl: "./bn-document-details.component.html",
  styleUrls: ["./bn-document-details.component.scss"],
  providers: [SortByDatePipe, SortPipe, SearchPipe]
})
export class BnDocumentDetailsComponent implements OnInit, OnDestroy {

  firstItemIndex;
  lastItemIndex;

  documents: any = [];
  filterType = "BC";
  filterKeys = "type,source";
  sortType: string;
  filterName = "All documents";
  loading = false;
  policyId: string;
  policyDetails: any = [];
  activePolicies: any = [];
  previous: any = [];
  showNoDocuments = false;
  user: any;
  documentsData: any = [];
  initialDocumentsData: any = [];
  loadingDocuments: boolean;
  isAvailable: boolean;
  isAcmic: boolean;
  blob: Blob;
  filterBy: string;
  showUpArrowIcon: boolean;
  upArrowForDocName: string;
  upArrowForDate: string;
  downArrowForDocName: string;
  downArrowForDate: string;
  filterUpAndDownIcon: string;
  company: any;
  isEligibleForUpload: boolean;
  policy: any;
  upArrowForDName: boolean;
  upArrowForDDate: boolean;
  upAndDownIconForDocName: string;
  upAndDownIconForDocDate: string;
  upAndDownIconForDocNameAcmic: string;
  upAndDownIconForDocDateAcmic: string;
  docActionClass: string;
  // toggleUpDownArrosForSort:
  /**
   *
   *  Information ----
   *  Many of these elements in here will become it's own component
   *  However I don't have the time at the moment to create a stand a lone version.
   *
   */

  constructor(
    private activatedRoute: ActivatedRoute,
    private policyDataService: PolicyDataService,
    private policyDetailsService: PolicyDetailsService,
    private userService: UserService,
    private walletCardService: WalletCardService,
    private storageServiceObservablesService: StorageServiceObservablesService,
    private documentsDataService: DocumentsDataService,
    private paperlessService: PaperlessService,
    private alertService: AlertService,
    private router: Router,
    private flagDataService: FlagDataService,
    private acmicService: AcmicService,
    private errorRedirectionService: ErrorRedirectionService,
    private idCardService: IdCardService,
    private companyTypeService: CompanyTypeService,
    private sortByDatePipe: SortByDatePipe,
    private sortPipe: SortPipe,
    private searchPipe: SearchPipe,
    private pbUploadService: PolicyBillingUploadService,
    private eventService: EventService,
    private elementRef: ElementRef,
    private urlValidationService: UrlValidationService
  ) {
    this.showUpArrowIcon = false;
    this.filterUpAndDownIcon = "assets/img/images/icon-simple-arrow-down.svg";
    this.upAndDownIconForDocName =
      "assets/img/images/icon-simple-arrow-down-black.svg";
    this.upAndDownIconForDocDate =
      "assets/img/images/icon-simple-arrow-down-black.svg";
    this.upAndDownIconForDocNameAcmic =
      "assets/img/images/arrow-down-acmic.svg";
    this.upAndDownIconForDocDateAcmic =
      "assets/img/images/arrow-down-acmic.svg";
    this.sortType = "";
    this.isEligibleForUpload = false;
    this.upArrowForDName = false;
    this.upArrowForDDate = false;
  }

  downloadWalletCard(email, policyid) {
    void policyid;
    this.walletCardService.generatePkPass(email).subscribe(
      //do noting
    );
  }

  onDownloadDocument(
    documentId: string,
    policyId: string,
    documentType: string,
    date: string,
    index
  ) {
    this.docActionClass = 'download-doc-action';
    this.documentsDataService.addCustomLoaderClass(index, this.elementRef, this.docActionClass)

    this.documentsDataService.getPolicyDocumentData(policyId,
      documentId,
      `${documentType}_${policyId}_${date}`,
      true,
      index
    );
  }

  onErrorResponse(err, policyId, description, indexToHideLoader) {
    this.documentsDataService.setCustomLoaderFlag(indexToHideLoader);
    if (err && err.error && err.error.Code === "965") {
      err.error.Message = err.error.Message.replace("DOC_NAME", description);
    }
    this.errorRedirectionService.errorRedirectHandler(err, policyId);
  }

  onSuccessResponseForPresigned(response, windowRef, indexToHideLoader) {
    this.documentsDataService.setCustomLoaderFlag(indexToHideLoader);

    if (response) {
      if (this.urlValidationService.isApprovedRedirectUrl(response?.presignedUrl)) {
        if (this.documentsDataService.isItIosDevice()) {
          if (!this.documentsDataService.handlePopupBlocker(windowRef)) {
            windowRef.location = response?.presignedUrl;
          }
        } else {
          const windowNonIos = window.open(response?.presignedUrl, '_blank');
          this.documentsDataService.handlePopupBlocker(windowNonIos);
        }
      }
    }
  }
  onViewDocument(
    documentId: string,
    policyId: string,
    documentType: string,
    date: string,
    description: string,
    index
  ) {
    this.docActionClass = 'view-doc-action';
    this.documentsDataService.addCustomLoaderClass(index, this.elementRef, this.docActionClass);
    if (Capacitor.isNativePlatform()) {
      this.documentsDataService.getPolicyDocumentData(policyId,
        documentId,
        `${documentType}_${policyId}_${date}`,
        false
      );
    } else {
      let windowRef;
      if (this.documentsDataService.isItIosDevice()) {
        windowRef = window.open();
      }
      this.policyDetailsService.getDocumentById(documentId, policyId).subscribe(
        (response) => {
          // this.onSuccessResponse(byteArray, windowRef);
          this.onSuccessResponseForPresigned(response, windowRef, index);

        },
        (err) => {
          this.onErrorResponse(err, policyId, description, index);
        }
      );
    }
  }
  /*
   * Next few methods are for the pagenation for the data tables
   * At this moment of time we are not using them but please do not remove them
   */
  onNextPageClick(data) {
    this.firstItemIndex = data.first;
    this.lastItemIndex = data.last;
  }

  onPreviousPageClick(data) {
    this.firstItemIndex = data.first;
    this.lastItemIndex = data.last;
  }
  toggleUpDownIcon() {
    this.showUpArrowIcon = !this.showUpArrowIcon;
    if (this.showUpArrowIcon) {
      this.filterUpAndDownIcon = "assets/img/images/icon-simple-arrow-up.svg";
    } else {
      this.filterUpAndDownIcon = "assets/img/images/icon-simple-arrow-down.svg";
    }
  }
  defaultIconsForName() {
    this.upArrowForDocName = "assets/img/images/icon-simple-arrow-up.svg";
    this.downArrowForDocName = "assets/img/images/icon-simple-arrow-down.svg";
  }
  defaultIconsForDate() {
    this.upArrowForDate = "assets/img/images/icon-simple-arrow-up.svg";
    this.downArrowForDate = "assets/img/images/icon-simple-arrow-down.svg";
  }
  setUpDownArrowForDocName() {
    this.upArrowForDocName = "assets/img/images/icon-simple-arrow-up-white.svg";
    this.downArrowForDocName =
      "assets/img/images/icon-simple-arrow-down-white.svg";
  }
  setUpDownArrowForDate() {
    this.upArrowForDate = "assets/img/images/icon-simple-arrow-up-white.svg";
    this.downArrowForDate =
      "assets/img/images/icon-simple-arrow-down-white.svg";
  }

  sortDocumentsByName(order) {
    this.setUpDownArrowForDocName();
    this.defaultIconsForDate();
    this.sortType = "doc-name";
    this.documentsData = this.sortPipe.transform(
      this.documentsData,
      "description",
      order
    );
  }
  sortDocumentsByDate(order) {
    let transaction = "transactionDate";
    if (order === "dsc") {
      transaction = "-transactionDate";
    }
    this.setUpDownArrowForDate();
    this.defaultIconsForName();
    this.sortType = "date";
    this.documentsData = this.sortByDatePipe.transform(
      this.documentsData,
      transaction
    );
  }
  toggleAndsortDocumentsByName() {
    this.upArrowForDName = !this.upArrowForDName;
    this.upAndDownIconForDocName = !this.upArrowForDName
      ? "assets/img/images/icon-simple-arrow-up-24.svg"
      : "assets/img/images/icon-simple-arrow-down-black.svg"

    const sortKey = !this.isEligibleForUpload && !this.isAcmic ? "description" : "fileName";

    this.documentsData.sort((a: any, b: any) => {
      const valueA = a[sortKey]?.toLowerCase() || "";
      const valueB = b[sortKey]?.toLowerCase() || "";

      if (valueA < valueB) return this.upArrowForDName ? -1 : 1;
      if (valueA > valueB) return this.upArrowForDName ? 1 : -1;
      return 0;
    });
  }
  toggleAndsortDocumentsByNameAcmic() {
    this.upArrowForDName = !this.upArrowForDName;
    this.upAndDownIconForDocNameAcmic = !this.upArrowForDName
      ? "assets/img/images/arrow-up-acmic.svg"
      : "assets/img/images/arrow-down-acmic.svg"

    const sortKey = !this.isEligibleForUpload && !this.isAcmic ? "description" : "fileName";

    this.documentsData.sort((a: any, b: any) => {
      const valueA = a[sortKey]?.toLowerCase() || "";
      const valueB = b[sortKey]?.toLowerCase() || "";

      if (valueA < valueB) return this.upArrowForDName ? -1 : 1;
      if (valueA > valueB) return this.upArrowForDName ? 1 : -1;
      return 0;
    });
  }
  toggleAndsortDocumentsByDate() {
    this.upArrowForDDate = !this.upArrowForDDate;
    if (this.upArrowForDDate) {
      this.upAndDownIconForDocDate =
        "assets/img/images/icon-simple-arrow-up-24.svg";
      this.documentsData = this.sortByDatePipe.transform(
        this.documentsData,
        "transactionDate"
      );
    } else {
      this.upAndDownIconForDocDate =
        "assets/img/images/icon-simple-arrow-down-black.svg";
      this.documentsData = this.sortByDatePipe.transform(
        this.documentsData,
        "-transactionDate"
      );
    }
  }
  toggleAndsortDocumentsByDateAcmic() {
    this.upArrowForDDate = !this.upArrowForDDate;
    if (this.upArrowForDDate) {
      this.upAndDownIconForDocDateAcmic =
        "assets/img/images/arrow-up-acmic.svg";
      this.documentsData = this.sortByDatePipe.transform(
        this.documentsData,
        "transactionDate"
      );
    } else {
      this.upAndDownIconForDocDateAcmic =
        "assets/img/images/arrow-down-acmic.svg";
      this.documentsData = this.sortByDatePipe.transform(
        this.documentsData,
        "-transactionDate"
      );
    }
  }

  getPolicyByPolicyNumber(policyList, policyId) {
    return policyList.find(
      (policy) => policy?.policynumber?.policyNumber === policyId
    );
  }

  applyFilter(policyDocuments, policyId) {

    if (policyId.length !== 10) {
      this.filterType = 'Billing';
      this.filterKeys = "docCategory";
    }
    const docs = this.searchPipe.transform(
      policyDocuments,
      this.filterKeys,
      this.filterType
    );
    this.documentsData = this.sortByDatePipe.transform(
      docs,
      "-transactionDate"
    );
  }
  getDocumentData(policyId) {
    this.policyDetailsService
      .getDocumentsByPolicy(policyId)
      .subscribe(
        (documentResponse) => {
          this.initialDocumentsData = [...documentResponse];
          this.applyFilter(documentResponse, policyId);
        }
      );
  }
  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.loading = true;
    this.loadingDocuments = true;
    this.defaultIconsForName();
    this.defaultIconsForDate();

    this.flagDataService.$flagDeatils.subscribe((response: FlagResponse) => {
      this.isAvailable = response.doc;
    });

    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyId = params["policyid"];
      this.documentsDataService.$renewalPoliciesDocumentData.subscribe(
        (policiesWithDocs) => {
          if (policiesWithDocs) {
            const policyDocuments = policiesWithDocs.find(
              (element) => element.policyNumber == this.policyId
            );
            if (policyDocuments) {
              this.initialDocumentsData = [...policyDocuments];
              this.applyFilter(policyDocuments, this.policyId);
              this.loadingDocuments = false;
            }
          }
          if (this.documentsData.length == 0) {
            this.policyDetailsService
              .getDocumentsByPolicy(this.policyId)
              .subscribe(
                (documentResponse) => {
                  this.initialDocumentsData = [...documentResponse];
                  this.applyFilter(documentResponse, this.policyId);
                  this.loadingDocuments = false;
                },
                (err) => {
                  this.loadingDocuments = false;
                  this.errorRedirectionService.errorRedirectHandler(
                    err,
                    this.policyId
                  );
                }
              );
          }
        }
      );

      this.userService.$user.subscribe((user) => {
        this.user = user;
      });

      this.policyDataService.$policyDetails.subscribe((policyResponse) => {
        if (policyResponse) {
          this.policyDetails = policyResponse;
          this.policy = this.getPolicyByPolicyNumber(
            this.policyDetails,
            this.policyId
          );
          this.isEligibleForUpload = this.pbUploadService.isMAGWPolicy(
            this.policy
          );
          this.activePolicies =
            this.policyDataService.getActiveAutoPolicies(policyResponse);
          this.loading = false;
        }
      });
    });
    this.company = this.companyTypeService.getCompany(this.policyId);
    this.eventService.childEventListner().subscribe(data => {
      if (data?.key === 'policy-from-documents-tab') {
        this.getDocumentData(data?.policy?.policynumber?.policyNumber);
      }
    });

    this.documentsDataService.getCustomLoader().subscribe(indexToHideLoader => {
      if (indexToHideLoader !== '') {
        this.documentsDataService.removeCustomLoaderClass(indexToHideLoader, this.elementRef, this.docActionClass);
        this.docActionClass = '';
      }
    });


  }

  viewEBILL() {
    const email = this.storageServiceObservablesService.getUserFromStorage();
    this.paperlessService.viewEBILL(email).subscribe(
      (response) => {
        this.documentsDataService.kubraLoginRequest(response);
      },
      () => {
        this.alertService.error("PROBLEM_IN_REQUEST_PROCESSING");
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
      }
    );
  }
  toggleIcon() {
    this.showUpArrowIcon = !this.showUpArrowIcon;
    if (this.showUpArrowIcon) {
      this.filterUpAndDownIcon = "assets/img/images/icon-simple-arrow-up.svg";
    } else {
      this.filterUpAndDownIcon = "assets/img/images/icon-simple-arrow-down.svg";
    }
  }

  @HostListener("click", ["$event"])
  hideOnClick(event) {
    if (
      !event.target.closest(".dropdown-doc-for-action") ||
      event.target.closest(".dropdown-menu")
    ) {
      this.toggleIcon();
    }
  }
  getIdCardDocument(vehicle, action, policy) {
    this.idCardService.getIdCard(
      policy,
      action,
      policy.policynumber.policyNumber,
      vehicle
    );
  }
  isMultiVehEligibleForIdCard(vehicle) {
    return vehicle
      ? vehicle.filter((veh) => veh.vehicleType !== "utility_trailer")
      : [];
  }
  ngOnDestroy() {
    this.documentsData = [];
  }
}